import React, { lazy, Suspense } from 'react';

import useMobileDetect from '../hooks/useMobileDetect';
import PageEmptyLoader from '../components/Layout/Page/PageEmptyLoader';

const Routes = lazy(() => import('./Routes'));
const MobileRoutes = lazy(() => import('./MobileRoutes'));

const RoutesByType = () => {
  const isMobile = useMobileDetect();

  return (
    <Suspense fallback={<PageEmptyLoader />}>{isMobile ? <MobileRoutes /> : <Routes />}</Suspense>
  );
};

export default RoutesByType;
